import React from 'react';
import PropTypes from 'prop-types'
import classNames from 'classnames';

import './FooterNav.scss';
import { I18n } from 'react-redux-i18n'

const FooterNavItem = ({ href, translationKey, isSelected }) => (
    <a
      className={classNames('FooterNavItem', {
        'is-selected': isSelected,
      })}
      href={href}
      aria-current={isSelected ? 'page' : undefined}
    >
      <div className='FooterNavItem__content'>
        <span className='FooterNavItem__content__text'>{I18n.t(translationKey)}</span>
      </div>
    </a>
)

const FooterNav = ({ items }) => (
  <nav className='FooterNav'>
    {items.map((item) => (
      <FooterNavItem
        key={item.keyId}
        href={item.href}
        translationKey={item.translationKey}
        isSelected={item.isSelected}
      />
    ))}
  </nav>
)

FooterNav.propTypes = {
  items: PropTypes.arrayOf(
    PropTypes.shape({
      href: PropTypes.string,
      translationKey: PropTypes.string,
      keyId: PropTypes.string,
      isSelected: PropTypes.bool,
    })
  ),
};

FooterNavItem.propTypes = {
  href: PropTypes.string,
  translationKey: PropTypes.string,
  isSelected: PropTypes.bool,
};

FooterNavItem.defaultProps = {
  isSelected: false,
};

export default FooterNav;
